module.exports = __webpack_public_path__ + "static/media/icons-solid-times.9c6c1df0.svg";